import { Injectable } from '@angular/core';

import { IdService } from '../../services/id.service';
import { WebsocketService } from '../../services/websocket/websocket.service';
import { WebsocketMessage, WebsocketMessageType } from '../../services/websocket/websocket.domain';
import { TimezoneService } from '../../services/date/timezone.service';

import { LearnProgress, LearnProgressforRecommendation } from './learn.domain';

@Injectable()
export class LearnProgressService {
  constructor(private websocketService: WebsocketService, private timezoneService: TimezoneService) {
    this.connectWebsocket();
  }

  sendProgress(data: LearnProgress): void {
    const message: WebsocketMessage<LearnProgress> = {
      correlationId: IdService.getUUID(),
      type: WebsocketMessageType.VIDEO,
      createdTimestamp: this.timezoneService.getCurrentDateInServerTimezone(),
      payload: data
    };
    this.websocketService.sendData(message);
  }

  sendDataforRecommendation(data: LearnProgressforRecommendation): void {
    const message: WebsocketMessage<LearnProgressforRecommendation> = {
      correlationId: IdService.getUUID(),
      type: WebsocketMessageType.VIDEO_RECOMMENDATION,
      createdTimestamp: this.timezoneService.getCurrentDateInServerTimezone(),
      payload: data
    };
    this.websocketService.sendData(message);
  }

  private connectWebsocket(): void {
    if (this.websocketService.isConnected() !== true) {
      this.websocketService.connect();
    }
  }
}

